<script>
	import { format } from '../services/i18n';
	export let params;
	console.log(params);
</script>

<p>{$format('text_route_not_found', { default: 'Failed to redirect' })}</p>
